
<template>
<div class="CajitaVentas" v-if="VentasPrin">
    <button type="button" class="btn btn-primary float-end" @click="VerAgregar()"><i class="bi bi-cart4"></i> Agregar</button>
    <h1 class="col-12">Ventas</h1>
    <div v-if="dataVentas.length==0" class="alert alert-danger text-center" role="alert">
        No hay datos disponibles
    </div>
    <div v-if="dataVentas.length!=0" class="table-responsive">
        <table class="table">
            <thead class="table-dark">
                <tr>
                    <th scope="col" class="text-center">#</th>
                    <th scope="col" class="text-center">Fecha de la venta</th>
                    <th scope="col" class="text-center">Monto</th>
                    <th scope="col" class="text-center">Total de productos</th>
                    <th scope="col" class="text-center">Tipo de venta</th>
                    <th scope="col" v-if="isAdmin">Usuario</th>
                    <th scope="col" class="text-center">Detalles</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(VenPro, i) in dataVentas" :key="i">
                    <th scope="row" class="text-center">{{i + 1}}</th>
                    <td class="text-center">{{ VenPro.VEN_FECHA }}</td>
                    <td class="text-center">${{ VenPro.VEN_MONTO }}</td>
                    <td class="text-center">{{ VenPro.VEN_CANTIDAD }}</td>
                    <td class="text-center">{{ VenPro.VEN_TIPOPAGO }}</td>
                    <td v-if="isAdmin">{{ VenPro.USU_NOMBRE }}</td>
                    <td>
                        <div class="d-flex justify-content-evenly text-center">
                            <button type="button" class="btn btn-outline-dark" @click="VerDetallesVenta(i)"><i class="bi bi-eye-fill"></i> Ver</button>
                            <button type="button" class="btn btn-outline-dark" @click="EditarDetallesVenta(i)"><i class="bi bi-pencil-square"></i> Editar</button>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>

<div class="CajitaAgregarVenta" v-if="VentAgregar">
    <button type="button" @click="CerrarAgregar()" class="btn btn-danger float-end"><i class="bi bi-x-lg"></i></button>
    <h1 class="col-12 mb-4">Agregar venta</h1>
    <div class="row">
        <div class="col-8 col-sm-10 col-md-10 col-lg-11 col-xl-11 col-xxl-11  mb-3">
            <label for="ProductSel" class="form-label fw-semibold">Producto</label>
            <select class="form-select" aria-label="Default select example" id="ProductSel">
              <option value="-1" selected></option>
              <option v-for="(product, i) in Productos" :key="i" :value="i">{{product.PRO_NOMBRE}}</option>
            </select>
        </div>
        <div class="col-4 col-sm-2 col-md-2 col-lg-1 col-xl-1 col-xxl-1 text-start mb-3">
            <label for="" class="form-label fw-semibold">Agregar</label>
            <div class="">
                <button class="btn btn-outline-dark" @click="AgregarVenta('ProductSel')" type="button"><i class="bi bi-plus-lg "></i></button>
            </div>
        </div>
        <hr>
    </div>
    <div v-if="dataProventa.length!=0" class="row">
        <div class="col-12 mb-3" v-for="(producto, j) in dataProventa" :key="j">
            <div class="row p-3 border bg-light" v-if="producto.estatus">
                <div class="col-9 col-sm-10 col-md-10 col-lg-11 col-xl-11 col-xxl-11 row">
                    <div class="mb-3 col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 col-xxl-3">
                        <label for="NomProduct{{j}}" class="form-label fw-semibold">Nombre del producto</label>
                        <input type="text" class="form-control" :id="'NomProduct'+j" placeholder="" :value="producto.nombre" disabled>
                    </div>
                    <div class="mb-3 col-12 col-sm-12 col-md-6 col-lg-3 col-xl-2 col-xxl-2">
                        <label for="ValUniProduct" class="form-label fw-semibold">En inventario</label>
                        <input type="text" class="form-control" :id="'ValUniProduct'+j" placeholder="" :value="producto.stock" disabled>
                    </div>
                    <div class="mb-3 col-12 col-sm-12 col-md-6 col-lg-3 col-xl-2 col-xxl-2">
                        <label for="CanProduct{{j}}" class="form-label fw-semibold">Cantidad</label>
                        <input type="number" :max="producto.stock" min="1" class="form-control" @change="TotalProducto(j,'CanProduct','TotProduct')" :id="'CanProduct'+j" placeholder="0" value="1">
                    </div>
                    <div class="mb-3 col-12 col-sm-12 col-md-6 col-lg-3 col-xl-2 col-xxl-2">
                        <label for="ValUniProduct" class="form-label fw-semibold">Valor unitario</label>
                        <input type="number" class="form-control" :id="'ValUniProduct'+j" placeholder="" :value="producto.precio" disabled>
                    </div>

                    <div class="mb-3 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-3 col-xxl-3">
                        <label for="TotProduct{{j}}" class="form-label fw-semibold">Total</label>
                        <input type="number" class="form-control TotProduct" :id="'TotProduct'+j" placeholder="0" :value="producto.precio" disabled>
                    </div>
                </div>
                <div class="mb-1 col-3 col-sm-2 col-md-2 col-lg-1 col-xl-1 col-xxl-1 d-flex justify-content-end align-items-center">
                    <button class="btn btn-danger mt-3" @click="EliminarProducto(j)" type="button "><i class="bi bi-trash "></i></button>
                </div>
            </div>
        </div>
        <hr>
        <div class="mb-3 col-12 col-sm-12 col-md-12 col-lg-6 col-xl-4 col-xxl-4 ">
            <label for="" class="form-label fw-semibold ">Tipo de venta</label>
            <select class="form-select" @change="TypePagos('TipoVen')" aria-label="Default select example" id="TipoVen">
              <option value="-1 " selected></option>
              <option value="1">Efectivo</option>
              <option value="2">Tarjeta de crédito</option>
              <option value="3">Tarjeta de débito</option>
            </select>
        </div>
        <div class="mb-3 col-12 col-sm-12 col-md-12 col-lg-6 col-xl-4 col-xxl-4 ">
            <label for="DescripVent" class="form-label fw-semibold ">Descripción</label>
            <input type="text " class="form-control " id="DescripVent" placeholder="">
        </div>
        <div class="mb-3 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-4 col-xxl-4 ">
            <label for="TotalVent" class="form-label fw-semibold ">Total</label>
            <input type="text " class="form-control " id="TotalVent" placeholder="" disabled>
        </div>
    </div>
    <div class="row" v-if="PagoEfectivo">
        <hr>
        <div class="mb-3 col-12 col-sm-12 col-md-12 col-lg-6 col-xl-4 col-xxl-4 ">
            <label for="DineroEfect" class="form-label fw-semibold">Dinero en efectivo</label>
            <input type="text" class="form-control" id="DineroEfect" placeholder="$0.00" @keypress="LHAValidaNumerosDeci($event)" @change="FormatoPN('DineroEfect','DineroCambio','TotalVent')">
        </div>
        <div class="mb-3 col-12 col-sm-12 col-md-12 col-lg-6 col-xl-4 col-xxl-4 ">
            <label for="DineroCambio" class="form-label fw-semibold ">Cambio</label>
            <input type="text" class="form-control" id="DineroCambio"  placeholder="$0.00" disabled>
            <!-- id="DineroCambio" -->
        </div>
        <div class="mb-3 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-4 col-xxl-4" v-if="HayCambio">
            <label for="" class="form-label"><span style="visibility: hidden; ">-</span></label>
            <div class="d-grid gap-2 ">
                <button class="btn btn-dark h-100" type="button" @click="Pagar()"><i class="bi bi-cash-coin "></i> Pagar</button>
            </div>
        </div>
    </div>

    <div class="mb-3 col-12 col-sm-12 col-md-12 col-lg-12 text-center" v-if="PagoTarjeta">
        <label for="" class="form-label"><span style="visibility: hidden; ">-</span></label>
        <div class="">
            <button class="btn btn-dark w-75" type="button" @click="Pagar()"><i class="bi bi-cash-coin "></i> Pagar</button>
        </div>
    </div>

</div>

<div class="Cargando" v-if="Cargando">
    <div class="wrapper">
        <div class="circle circle1"></div>
        <div class="circle circle2"></div>
        <div class="circle circle3"></div>
        <div class="shadow"></div>
        <div class="shadow"></div>
        <div class="shadow"></div>
        <span>Cargando</span>
    </div>
</div>

<div class="ModalVerVenta" v-if="VerVentasPro">
    <div class="ContentMVVent">
        <i class="bi bi-x-square-fill iconCerrar" @click="CerrarVerVent()"></i>
        <div class="row  g-4">
            <h2 class="col-12 mb-4 text-center ">Vista previa</h2>
            <div class="mb-2 placeholder-glow col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-4" v-if="isAdmin">
                <label class="placeholder form-label fw-semibold">Vendedor:</label><br>
                <label class="placeholder form-label">{{ dataVentas[position].USU_NOMBRE  }}</label>
            </div>
            <div class="mb-2 placeholder-glow col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-4" v-if="isAdmin">
                <label class="placeholder form-label fw-semibold">Tipo de pago:</label><br>
                <label class="placeholder form-label">{{ dataVentas[position].VEN_TIPOPAGO }}</label>
            </div>
            <div class="mb-2 placeholder-glow col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-4" v-if="isAdmin">
                <label class="placeholder form-label fw-semibold">Total de la compra:</label><br>
                <label class="placeholder form-label">${{ dataVentas[position].VEN_MONTO }}</label>
            </div>
            <div class="mb-2 placeholder-glow col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6" v-if="!isAdmin">
                <label class="placeholder form-label fw-semibold">Tipo de pago:</label><br>
                <label class="placeholder form-label">{{ dataVentas[position].VEN_TIPOPAGO }}</label>
            </div>
            <div class="mb-2 placeholder-glow col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6" v-if="!isAdmin">
                <label class="placeholder form-label fw-semibold">Total de la compra:</label><br>
                <label class="placeholder form-label">${{ dataVentas[position].VEN_MONTO }}</label>
            </div>
            <div class="mb-2 placeholder-glow col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                <label class="placeholder form-label fw-semibold">Fecha de la venta:</label><br>
                <label class="placeholder form-label">{{ dataVentas[position].VEN_FECHA }}.</label>
            </div>
            <div class="mb-3 placeholder-glow col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12" v-if="dataVentas[position].VEN_DESC!=''">
                <label class="placeholder form-label fw-semibold">Descripción:</label><br>
                <label class="placeholder form-label">{{ dataVentas[position].VEN_DESC }}.</label>
            </div>
            <div v-if="this.dataProVentaV.length!=0" class="table-responsive col-12">
                <table class="table">
                    <thead class="table-dark">
                        <tr>
                            <th scope="col" class="text-center">
                                <div class="placeholder-glow">
                                    <label class="placeholder form-label fw-semibold">#</label>
                                </div>
                            </th>
                            <th scope="col" class="text-center">
                                <div class="placeholder-glow">
                                    <label class="placeholder form-label fw-semibold">Nombre del producto</label>
                                </div>
                            </th>
                            <th scope="col" class="text-center">
                                <div class="placeholder-glow">
                                    <label class="placeholder form-label fw-semibold">Cantidad</label>
                                </div>
                            </th>
                            <th scope="col" class="text-center">
                                <div class="placeholder-glow">
                                    <label class="placeholder form-label fw-semibold">Total</label>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(VenPro , i) in this.dataProVentaV" :key="i">
                            <th scope="row" class="text-center">
                                <div class="placeholder-glow">
                                    <label class="placeholder form-label">{{i + 1}}</label>
                                </div>
                            </th>
                            <td class="text-center">
                                <div class="placeholder-glow text-center">
                                    <label class=" placeholder form-label">{{ VenPro.nombre }}</label>
                                </div>
                            </td>
                            <td class="text-center">
                                <div class="placeholder-glow ">
                                    <label class="placeholder form-label">{{ VenPro.cantidad }}</label>
                                </div>
                            </td>
                            <td class="text-center">
                                <div class=" placeholder-glow">
                                    <label class="placeholder form-label">${{ VenPro.total }}</label>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>

<div class="ModalVerVenta" v-if="EditVentasPro">
    <div class="ContentMVVent">
        <i class="bi bi-x-square-fill iconCerrar" @click="CerrarEditarVent()"></i>
        <div class="row  g-3">
            <h2 class="col-12 mb-4 text-center ">Editar venta</h2>
            <div class="mb-2 placeholder-glow col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6" v-if="isAdmin">
                <label class="placeholder form-label fw-semibold">Vendedor:</label><br>
                <label class="placeholder form-label">{{ dataVentas[position].USU_NOMBRE  }}</label>
            </div>
            <div class="mb-2 placeholder-glow col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6">
                <label class="placeholder form-label fw-semibold">Tipo de pago:</label><br>
                <label class="placeholder form-label">{{ dataVentas[position].VEN_TIPOPAGO }}</label>
            </div>
            <div class="mb-2 placeholder-glow col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6">
                <label class="placeholder form-label fw-semibold">Total de la compra:</label><br>
                <label class="placeholder form-label">${{ dataVentas[position].VEN_MONTO }}</label>
            </div>
            <div class="mb-2 placeholder-glow col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6" v-if="isAdmin">
                <label class="placeholder form-label fw-semibold">Fecha de la venta:</label><br>
                <label class="placeholder form-label">{{ dataVentas[position].VEN_FECHA }}.</label>
            </div>
            <div class="mb-2 placeholder-glow col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12" v-if="!isAdmin">
                <label class="placeholder form-label fw-semibold">Fecha de la venta:</label><br>
                <label class="placeholder form-label">{{ dataVentas[position].VEN_FECHA }}.</label>
            </div>
            <div class="mb-3 placeholder-glow col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                <label class="placeholder form-label fw-semibold">Descripción:</label><br>
                <label class="placeholder form-label w-100" v-if="!VerinputsEdit">{{ dataVentas[position].VEN_DESC }}.</label>
                <input type="text" class="form-control" id="descEdit"  placeholder="" :value="dataVentas[position].VEN_DESC " v-if="VerinputsEdit">
                <!-- id="descEdit" -->
            </div>
            <div v-if="this.dataProVentaV.length!=0" class="table-responsive col-12">
                <table class="table">
                    <thead class="table-dark">
                        <tr>
                            <th scope="col" class="text-center">
                                <div class="placeholder-glow">
                                    <label class="placeholder form-label fw-semibold">#</label>
                                </div>
                            </th>
                            <th scope="col" class="text-center">
                                <div class="placeholder-glow">
                                    <label class="placeholder form-label fw-semibold">Nombre del producto</label>
                                </div>
                            </th>
                            <th scope="col" class="text-center">
                                <div class="placeholder-glow">
                                    <label class="placeholder form-label fw-semibold">Cantidad</label>
                                </div>
                            </th>
                            <th scope="col" class="text-center">
                                <div class="placeholder-glow">
                                    <label class="placeholder form-label fw-semibold">Total</label>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(VenPro, i) in this.dataProVentaV" :key="i">
                            <th scope="row" class="text-center">
                                <div class="placeholder-glow">
                                    <label class="placeholder form-label">{{i + 1}}</label>
                                </div>
                            </th>
                            <td class="text-center">
                                <div class="placeholder-glow text-center">
                                    <label class=" placeholder form-label">{{ VenPro.nombre }}</label>
                                </div>
                            </td>
                            <td class="text-center">
                                <div class="placeholder-glow ">
                                    <label class="placeholder form-label">{{ VenPro.cantidad }}</label>
                                </div>
                            </td>
                            <td class="text-center">
                                <div class=" placeholder-glow">
                                    <label class="placeholder form-label">${{ VenPro.total }}</label>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="col-12 placeholder-glow text-center">
                <div class="d-grid gap-2 d-md-flex justify-content-md-center">
                    <button class="btn btn-primary w-100" type="button" @click="GuardaEdit('descEdit')" v-if="VerinputsEdit">Guardar</button>
                </div>
                <a href="#" tabindex="-1" class="btn btn-primary placeholder disabled w-100" v-if="!VerinputsEdit"></a>
            </div>
        </div>
    </div>
</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Swal from 'sweetalert2';

export default defineComponent({
    name: 'VentasVue',
    data() {

        let isAdmin:any = false;
        let LlegaLogin:any = [];

        let Cargando = true;
        let VentasPrin = true;
        let VentAgregar = false;
        let PagoEfectivo = false;
        let PagoTarjeta = false;
        let VerVentasPro = false;
        let EditVentasPro = false;
        let VerinputsEdit  = false;
        let HayCambio = false;

        let dataVentas:Array<any> = [];
        let Productos:Array<any> = [];
        let Productos2:Array<any> = [];
        let dataProventa:Array<any> = [];
        let dataProVentaV:Array<any> = [];

        let FechaActual = new Date() as Date;
        let FechaActual2 = '';

        let position = -1;
        return { Cargando, VentasPrin, VentAgregar, PagoEfectivo, PagoTarjeta, VerVentasPro, EditVentasPro, VerinputsEdit, dataVentas, Productos, Productos2, dataProventa, dataProVentaV, FechaActual, FechaActual2, position, HayCambio, LlegaLogin, isAdmin }
    },
    mounted() {
        // this.verVentas();
        this.ValidaInicio();
    },
    methods: {
        async ValidaInicio(){
             let data:any = localStorage.getItem('InicioL');
            let inicio = JSON.parse(data);
            if(inicio!=null){
                // let data:any = await this.Miservicio.ValidaUser(inicio[0].Usuario,inicio[0].Contrase); 
                const formDataLogin = new URLSearchParams();
                formDataLogin.append('usu', inicio[0].Usuario);  
                formDataLogin.append('contra', inicio[0].Contrase);  
                let data2:any = await fetch("https://tesis.lmspace.com.mx/php/TiendaT/LHA/login.php", {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded'
                        },
                        body: 
                            formDataLogin.toString()
                        });
                // console.log(data2);
                let data = await data2.json();
                // console.log('%c 🌸 data','color:#CF8103;');
                // console.log(this.LlegaLogin[0].USU_TIPO);
                if(data[0].RESPONSE=="1"){
                    if(data[0].USU_ESTATUS=="1"){
                        this.LlegaLogin = data;
                        setTimeout(() => {
                            this.IsertData();
                        }, 1000);
                    }else{
                        localStorage.clear();
                    }
                }else{
                    localStorage.clear();
                }
            }else{
                localStorage.clear();    
            }
        },
        IsertData(){
            // console.log('%c 🌸 data','color:#CF8103;');
            // console.log(this.LlegaLogin[0].USU_TIPO);
            if(this.LlegaLogin[0].USU_TIPO=='ADMIN'){
            this.isAdmin=true;
            }else{
            this.isAdmin=false;
            }
            this.verVentas();
        },
        async verVentas(){
            this.dataVentas = [];
            if(this.isAdmin==true){
            // let data:any = await this.MiServicio.setAllVentas();
            // console.log(data)
            // data = data.replaceAll("'",'"')
            let AllVen = true;
            const formDataVentas = new URLSearchParams();
                formDataVentas.append('AllVentas', AllVen.toString());   
                let data2:any = await fetch("https://tesis.lmspace.com.mx/php/TiendaT/LHA/consultas.php", {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded'
                        },
                        body: 
                            formDataVentas.toString()
                        });
            // console.log(data2);
            let data = await data2.json();
            this.dataVentas = data;
            console.log(data);
            for (const item of this.dataVentas) {
                let detalles = JSON.parse(item.VEN_DETALLES);
                console.log(detalles)
                item.VEN_CANTIDAD = ''+detalles.length;
            }
            this.GetProducts();
            this.Cargando = false;
            }else{
            // let data:any = await this.MiServicio.setAllMisVentas(this.LlegaLogin[0].USU_ID);
            const formDataVentas = new URLSearchParams();
                formDataVentas.append('id_userV', this.LlegaLogin[0].USU_ID);   
                let data2:any = await fetch("https://tesis.lmspace.com.mx/php/TiendaT/LHA/consultas.php", {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded'
                        },
                        body: 
                            formDataVentas.toString()
                        });
            // console.log(data2);
            let data = await data2.json();
            this.dataVentas = data;
            console.log(data);
            for (const item of this.dataVentas) {
                let detalles = JSON.parse(item.VEN_DETALLES);
                item.VEN_CANTIDAD = ''+detalles.length;
            }
            this.GetProducts();
            this.Cargando= false;
            }
        },
        async GetProducts(){
            this.Productos = [];
            this.Productos2 = [];
            // let data:any = await this.MiServicio.setAllProductos();
            // console.log(data);
            let AllPro = true;
            const formDataVentas = new URLSearchParams();
                formDataVentas.append('AllProductos', AllPro.toString());   
                let data2:any = await fetch("https://tesis.lmspace.com.mx/php/TiendaT/LHA/consultas.php", {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded'
                        },
                        body: 
                            formDataVentas.toString()
                        });
            // console.log(data2);
            let data = await data2.json();
            console.log('%c 🌸 data','color:#CF8103;');
            console.log(data);
            for (const item of data) {
            // console.log(item)
            if(item.PRO_STATUS==1 && item.PRO_CANTIDAD>0){
                this.Productos.push(item);
            }
            this.Productos2.push(item);
            }
            this.Productos.sort(function(a, b) {
            return a.PRO_ID - b.PRO_ID;
            });
        },
        VerAgregar(){
            this.VentasPrin = false;
            this.VentAgregar = true;
            this.PagoEfectivo = false;
            this.PagoTarjeta = false;
            this.dataProventa = [];
            this.GetProducts();
        },
        CerrarAgregar(){
            this.VentasPrin = true;
            this.VentAgregar = false;
        },
        AgregarVenta(id:string){
            //ProductSel
            let selectProduct:any = document.getElementById(id);
            // console.log(selectProduct.value);
            if(selectProduct.value!='-1'){
            let posicion:any = Number(selectProduct.value);
            if(this.dataProventa.length==0){
                this.dataProventa.push({
                estatus: true,
                nombre: this.Productos[posicion].PRO_NOMBRE,
                precio: Number(this.Productos[posicion].PRO_PRECIO).toFixed(2),
                valoru: Number(this.Productos[posicion].PRO_PRECIO),
                stock: this.Productos[posicion].PRO_CANTIDAD,
                id: this.Productos[posicion].PRO_ID,
                data: this.Productos[posicion]
                });
                this.Productos.splice(posicion,1);
            }else{
                //console.log(this.dataProventa);
                if(this.dataProventa.find( producto => producto.nombre === ''+this.Productos[posicion].PRO_NOMBRE ) == undefined){
                this.dataProventa.push({
                    estatus: true,
                    nombre: this.Productos[posicion].PRO_NOMBRE,
                    precio: Number(this.Productos[posicion].PRO_PRECIO).toFixed(2),
                    valoru: Number(this.Productos[posicion].PRO_PRECIO),
                    stock: this.Productos[posicion].PRO_CANTIDAD,
                    id: this.Productos[posicion].PRO_ID,
                    data: this.Productos[posicion]
                });
                this.Productos.splice(posicion,1);
                }else{
                let resultado = this.dataProventa.find( producto => producto.nombre === ''+this.Productos[posicion].PRO_NOMBRE );
                resultado.estatus = true;
                this.Productos.splice(posicion,1);
                }
            }
            }
            setTimeout(() => {
            this.TotalFinalProducto();
            }, 10);

            /*const inventario = [
                {nombre: 'manzanas', cantidad: 2},
                {nombre: 'bananas', cantidad: 0},
                {nombre: 'cerezas', cantidad: 5}
            ];
            const resultado = inventario.find( fruta => fruta.nombre === 'cerezas' );
            console.log(resultado);*/

        },
        TotalProducto(posicion:any, idCan:string,idTotal:string){
            let inputCan:any = document.getElementById(idCan+posicion);
            let inputValUni:any = this.dataProventa[posicion].valoru;
            let inputTotal:any = document.getElementById(idTotal+posicion);
            let Cantidad:any = Number(inputCan.value);
            let Stock:any = this.dataProventa[posicion].stock;
            if(Cantidad<=0){
            inputCan.value='1';
            }
            if(Cantidad>Stock){
            inputCan.value = this.dataProventa[posicion].stock;
            }
            inputTotal.value= (Number(inputValUni) * Number(inputCan.value)).toFixed(2);
            //TotProduct.value = Number(producto.precio) * Number(CanProduct.value)
            this.TotalFinalProducto();
        },
        EliminarProducto(posicion:number){
            this.Productos.push(this.dataProventa[posicion].data);
            this.dataProventa[posicion].estatus = false;
            //this.dataProventa.splice(posicion,1);
            this.Productos.sort(function(a, b) {
            return a.PRO_ID - b.PRO_ID;
            });
            let falso = 0;
            for (const item of this.dataProventa) {
            if(item.estatus==false){
                falso++;
            }
            }
            if(falso==this.dataProventa.length){
            this.dataProventa=[];
            this.PagoEfectivo = false;
            this.PagoTarjeta = false;
            }else{
            setTimeout(() => {
                this.TotalFinalProducto();
                if(this.PagoEfectivo==true){
                this.FormatoPN('DineroEfect','DineroCambio','TotalVent');
                }
            }, 10);
            }
        },
        TypePagos( id: string ){
            this.HayCambio = false;
            // console.log(id);
            let SelctTipVe:any = document.getElementById(id);
            // console.log(SelctTipVe);
            // console.log(SelctTipVe.value);
            if(SelctTipVe.value!='-1'){
                // console.log('%c 🌸 UwU','color:#CF8103;');
                switch (SelctTipVe.value) {
                    case '1':
                    this.PagoEfectivo = true;
                    this.PagoTarjeta = false;
                    // console.log('%c 🌸 1','color:#CF8103;');
                    break;
                    case '2':
                    this.PagoEfectivo = false;
                    this.PagoTarjeta = true;
                    // console.log('%c 🌸 2','color:#CF8103;');
                    break;
                    case '3':
                    this.PagoEfectivo = false;
                    this.PagoTarjeta = true;
                    // console.log('%c 🌸 3','color:#CF8103;');
                    break;
                    default:
                    console.log('Lo lamentamos, por el momento no disponemos de ' + SelctTipVe.value + '.');
                    this.PagoEfectivo = false;
                    this.PagoTarjeta = false;
                }
            }
        },
        TotalFinalProducto(){
            let Total:any = 0;
            let inputTotal:any = document.getElementById('TotalVent');
            let input:any =  document.getElementsByClassName('TotProduct');
            for (let i = 0 ;i<input.length;i++) {
            let inputTfinal = input[i];
            Total += Number(inputTfinal.value);
            }
            if(input.length!=0){
            inputTotal.value = Total.toFixed(2);
            }
            if(this.PagoEfectivo==true){
            this.FormatoPN('DineroEfect','DineroCambio','TotalVent');
            }
        },
        LHAValidaNumerosDeci(datosevent:any) {
            var dato = window.Event ? datosevent.which : datosevent.keyCode
            return (dato >= 48 && dato <= 57 || dato == 8 || dato == 46)
        },
        FormatoPN(id:string, idCambio:string, idTotal:string){
            this.HayCambio = true;
            // console.log(id);
            // console.log(idCambio);
            // console.log(idTotal);
            let input:any = document.getElementById(id);
            // console.log(input);
            let vali:any = input.value;
            // console.log(vali);
            input.value = vali.replace(/[^0-9\u00f1\u00d1\s.]/g,"");
            let inputCambio:any = document.getElementById(idCambio);
            // console.log(inputCambio);
            let inputTotal:any = document.getElementById(idTotal);
            // console.log(inputTotal);
            inputCambio.value = '$' + (Number(input.value) - Number(inputTotal.value)).toFixed(2);
        },
        async Pagar(){
            this.FechaActual2 = this.FechaActual.toLocaleDateString('es-MX',{ year: 'numeric', month: '2-digit', day: '2-digit' });
            let Monto:any = document.getElementById('TotalVent');
            let TipoVenta:any = document.getElementById('TipoVen');
            let DescVenta:any = document.getElementById('DescripVent');
            let DetallesVent = [];
            let Registro = [];
            let ActuPro = [];
            for (let i = 0; i < this.dataProventa.length; i++) {
                let item = this.dataProventa[i];
                if(item.estatus==true){
                    let Catidad:any = document.getElementById('CanProduct'+i);
                    let TotalP:any = document.getElementById('TotProduct'+i);
                    DetallesVent.push({
                    "idProd": item.id,
                    "cantidad": Catidad.value,
                    "total": TotalP.value,
                    "descuento":"0%"
                    });
                }
            }
            console.log(this.dataProventa);
            console.log(DetallesVent);
            if(TipoVenta.value!='-1'){
            switch (TipoVenta.value) {
                case '1':
                Registro = [];
                ActuPro = [];
                // let resultado1:any = await this.MiServicio.InsertVenta(this.LlegaLogin[0].USU_ID,Monto.value,'Efectivo','0%',JSON.stringify(DetallesVent),DescVenta.value);
                //[{idVenta : "1"}]
                var formDataVentasIn2 = new URLSearchParams();
                    formDataVentasIn2.append('USU_ID', this.LlegaLogin[0].USU_ID);   
                    formDataVentasIn2.append('MONTO', Monto.value);   
                    formDataVentasIn2.append('TIPO', 'Efectivo');   
                    formDataVentasIn2.append('DESCU', '0%');   
                    formDataVentasIn2.append('DETALLES', JSON.stringify(DetallesVent));   
                    formDataVentasIn2.append('DESCRIP', DescVenta.value);  
                    
                var respcase1  = await fetch("https://tesis.lmspace.com.mx/php/TiendaT/LHA/consultas.php", {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    body: formDataVentasIn2.toString()
                });
                
                console.log(respcase1);
                var resultado1 = await respcase1.json();
                console.log('%c 🌸 resultado1','color:#CF8103;');
                console.log(resultado1);
                if(resultado1[0].RESPONSE == '1'){
                    for (let i = 0; i < this.dataProventa.length; i++) {
                    let item = this.dataProventa[i];
                    if(item.estatus==true){
                        let Catidad:any = document.getElementById('CanProduct'+i);
                        let CatidadFinal:any = Number(item.stock) - Number(Catidad.value);

                        // let resPV:any = await this.MiServicio.InsertProductVenta(resultado1[0].idVenta,item.id);
                        // let respPU:any = await this.MiServicio.UpdateProductoCantidad(CatidadFinal,item.id);
                        const formDataVentasI = new URLSearchParams();
                            formDataVentasI.append('PVEN_ID', resultado1[0].idVenta);   
                            formDataVentasI.append('PPRO_ID', item.id);     
                        var resPV2:any = await fetch("https://tesis.lmspace.com.mx/php/TiendaT/LHA/consultas.php", {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded'
                            },
                            body: 
                                formDataVentasI.toString()
                        });
                        var resPV = await resPV2.json();
                        console.log('%c 🌸 resPV','color:#CF8103;');
                        console.log(resPV);

                        const formDataVentasU = new URLSearchParams();
                            formDataVentasU.append('PRO_Cantidad', (Number(item.stock)-Number(DetallesVent[0].cantidad) ).toString()   );   
                            formDataVentasU.append('Producto_id', DetallesVent[0].idProd);     
                        let respPU2:any = await fetch("https://tesis.lmspace.com.mx/php/TiendaT/LHA/consultas.php", {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded'
                            },
                            body: 
                                formDataVentasU.toString()
                        });
                        let respPU = await respPU2.json();
                        console.log('%c 🌸 respPU','color:#CF8103;');
                        console.log(respPU);

                        if(resPV.Response=='Registro Exitoso'){
                        Registro.push({
                            id:item.id,
                            data: item.data,
                            Response: resPV.Response
                        });
                        }
                        if(respPU.Response=='Actualización Exitosa'){
                        ActuPro.push({
                            id:item.id,
                            data: item.data,
                            Response: respPU.Response
                        });
                        }
                        console.log(DetallesVent);
                        console.log(Registro);
                        console.log(ActuPro);
                        if(DetallesVent.length == Registro.length && DetallesVent.length == ActuPro.length){
                        Swal.fire({
                            icon: 'success',
                            title: 'Venta registrada con éxito.',
                            showConfirmButton: false,
                            showCloseButton: true,
                        });
                        this.Cargando = true;
                        this.verVentas();
                        this.VentasPrin = true;
                        this.VentAgregar = false;
                        }
                    }
                    }
                }
                break;
                case '2':
                Registro = [];
                ActuPro = [];
                // let resultado2:any = await this.MiServicio.InsertVenta(this.LlegaLogin[0].USU_ID,Monto.value,'Credito','0%',JSON.stringify(DetallesVent),DescVenta.value);
                //[{idVenta : "1"}]

                var formDataVentasIn22 = new URLSearchParams();
                formDataVentasIn22.append('USU_ID', this.LlegaLogin[0].USU_ID);   
                formDataVentasIn22.append('MONTO', Monto.value);   
                formDataVentasIn22.append('TIPO', 'Efectivo');   
                formDataVentasIn22.append('DESCU', '0%');   
                formDataVentasIn22.append('DETALLES', JSON.stringify(DetallesVent));   
                formDataVentasIn22.append('DESCRIP', DescVenta.value);  
                    
                var respcase2  = await fetch("https://tesis.lmspace.com.mx/php/TiendaT/LHA/consultas.php", {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    body: formDataVentasIn22.toString()
                });
                
                console.log(respcase2);
                var resultado2 = await respcase2.json();
                console.log('%c 🌸 resultado2','color:#CF8103;');
                console.log(resultado2);

                if(resultado2[0].RESPONSE == '1'){
                    for (let i = 0; i < this.dataProventa.length; i++) {
                    let item = this.dataProventa[i];
                    if(item.estatus==true){
                        let Catidad:any = document.getElementById('CanProduct'+i)!;
                        console.log(Catidad);
                        let CatidadFinal:any = Number(item.stock) - Number(Catidad.value);
                        console.log(CatidadFinal);
                        // let resPV:any = await this.MiServicio.InsertProductVenta(resultado2[0].idVenta,item.id);
                        // let respPU:any = await this.MiServicio.UpdateProductoCantidad(CatidadFinal,item.id);
                        const formDataVentasI2 = new URLSearchParams();
                            formDataVentasI2.append('PVEN_ID', resultado2[0].idVenta);   
                            formDataVentasI2.append('PPRO_ID', item.id);     
                        var resPV22:any = await fetch("https://tesis.lmspace.com.mx/php/TiendaT/LHA/consultas.php", {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded'
                            },
                            body: 
                                formDataVentasI2.toString()
                        });
                        var resPVcase2 = await resPV22.json();
                        console.log('%c 🌸 resPV','color:#CF8103;');
                        console.log(resPVcase2);

                        const formDataVentasU = new URLSearchParams();
                            formDataVentasU.append('PRO_Cantidad', CatidadFinal.toString()   );   
                            formDataVentasU.append('Producto_id', DetallesVent[0].idProd);     
                        let respPU2:any = await fetch("https://tesis.lmspace.com.mx/php/TiendaT/LHA/consultas.php", {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded'
                            },
                            body: 
                                formDataVentasU.toString()
                        });
                        let respPU = await respPU2.json();
                        console.log('%c 🌸 respPU','color:#CF8103;');
                        console.log(respPU);
                        if(resPVcase2.Response=='Registro Exitoso'){
                        Registro.push({
                            id:item.id,
                            data: item.data,
                            Response: resPVcase2.Response
                        });
                        }
                        if(respPU.Response=='Actualización Exitosa'){
                        ActuPro.push({
                            id:item.id,
                            data: item.data,
                            Response: respPU.Response
                        });
                        }
                        if(DetallesVent.length == Registro.length && DetallesVent.length == ActuPro.length){
                        Swal.fire({
                            icon: 'success',
                            title: 'Venta registrada con éxito.',
                            showConfirmButton: false,
                            showCloseButton: true,
                        });
                        this.Cargando = true;
                        this.verVentas();
                        this.VentasPrin = true;
                        this.VentAgregar = false;
                        }
                    }
                    }
                }
                break;
                case '3':
                Registro = [];
                ActuPro = [];
                // let resultado3:any = await this.MiServicio.InsertVenta(this.LlegaLogin[0].USU_ID,Monto.value,'Debito','0%',JSON.stringify(DetallesVent),DescVenta.value);
                //[{idVenta : "1"}]
                var formDataVentasIn3 = new URLSearchParams();
                    formDataVentasIn3.append('USU_ID', this.LlegaLogin[0].USU_ID);   
                    formDataVentasIn3.append('MONTO', Monto.value);   
                    formDataVentasIn3.append('TIPO', 'Efectivo');   
                    formDataVentasIn3.append('DESCU', '0%');   
                    formDataVentasIn3.append('DETALLES', JSON.stringify(DetallesVent));   
                    formDataVentasIn3.append('DESCRIP', DescVenta.value);  
                    
                var respcase3  = await fetch("https://tesis.lmspace.com.mx/php/TiendaT/LHA/consultas.php", {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    body: formDataVentasIn3.toString()
                });
                
                console.log(respcase3);
                var resultado3 = await respcase3.json();
                console.log('%c 🌸 resultado1','color:#CF8103;');
                console.log(resultado3);

                if(resultado3[0].RESPONSE == '1'){
                    for (let i = 0; i < this.dataProventa.length; i++) {
                    let item = this.dataProventa[i];
                    if(item.estatus==true){
                        let Catidad:any = document.getElementById('CanProduct'+i);
                        let CatidadFinal:any = Number(item.stock) - Number(Catidad.value);
                        // let resPV:any = await this.MiServicio.InsertProductVenta(resultado3[0].idVenta,item.id);
                        // let respPU:any = await this.MiServicio.UpdateProductoCantidad(CatidadFinal,item.id);


                            const formDataVentasI = new URLSearchParams();
                            formDataVentasI.append('PVEN_ID', resultado3[0].idVenta);   
                            formDataVentasI.append('PPRO_ID', item.id);     
                        var resPV4:any = await fetch("https://tesis.lmspace.com.mx/php/TiendaT/LHA/consultas.php", {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded'
                            },
                            body: 
                                formDataVentasI.toString()
                        });
                        var resPV3 = await resPV4.json();
                        console.log('%c 🌸 resPV','color:#CF8103;');
                        console.log(resPV3);

                        const formDataVentasU = new URLSearchParams();
                            formDataVentasU.append('PRO_Cantidad', (Number(item.stock)-Number(DetallesVent[0].cantidad) ).toString()   );   
                            formDataVentasU.append('Producto_id', DetallesVent[0].idProd);     
                        let respPU2:any = await fetch("https://tesis.lmspace.com.mx/php/TiendaT/LHA/consultas.php", {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded'
                            },
                            body: 
                                formDataVentasU.toString()
                        });
                        let respPU = await respPU2.json();
                        console.log('%c 🌸 respPU','color:#CF8103;');
                        console.log(respPU);

                        if(resPV3.Response=='Registro Exitoso'){
                            Registro.push({
                                id:item.id,
                                data: item.data,
                                Response: resPV3.Response
                            });
                        }
                        if(respPU.Response=='Actualización Exitosa'){
                            ActuPro.push({
                                id:item.id,
                                data: item.data,
                                Response: respPU.Response
                            });
                        }
                    }
                    }
                    if(DetallesVent.length == Registro.length && DetallesVent.length == ActuPro.length){
                    Swal.fire({
                        icon: 'success',
                        title: 'Venta registrada con éxito.',
                        showConfirmButton: false,
                        showCloseButton: true,
                    });
                    this.Cargando = true;
                    this.verVentas();
                    this.VentasPrin = true;
                    this.VentAgregar = false;
                    }
                }/**/
                break;
                default:
                console.log('Lo lamentamos, por el momento no disponemos de ' + TipoVenta.value + '.');
                }
            }
        },
        VerDetallesVenta(posicion:number){
            this.VerVentasPro = true;
            this.dataProVentaV = [];
            this.position = -1;
            this.position = posicion;
            let detalles = JSON.parse(this.dataVentas[posicion].VEN_DETALLES);
            // console.log(detalles)
            // console.log(this.Productos);
            for (const item of detalles) {
            // for (const item2 of this.Productos) {
            for (const item2 of this.Productos2) {
                if(item.idProd == item2.PRO_ID){
                this.dataProVentaV.push({
                    idProd: item.idProd,
                    nombre: item2.PRO_NOMBRE,
                    cantidad: item.cantidad,
                    total: item.total
                })
                }
            }
            }
            setTimeout(() => {
            this.Removerclass();
            }, 900);
        },
        CerrarVerVent(){
            this.VentasPrin = true;
            this.VentAgregar = false;
            this.VerVentasPro = false;
        },
        Removerclass(){
            let placeholder = document.getElementsByClassName('form-label');
            for(let a = 0;a<placeholder.length; a++){
            placeholder[a].classList.remove('placeholder');
            }
        },
        EditarDetallesVenta(posicion:number){
            this.VerinputsEdit = false;
            this.VentAgregar = false;
            this.VerVentasPro = false;
            this.EditVentasPro = true;
            this.dataProVentaV = [];
            this.position = -1;
            this.position = posicion;
            let detalles = JSON.parse(this.dataVentas[posicion].VEN_DETALLES);
            for (const item of detalles) {
            for (const item2 of this.Productos) {
                if(item.idProd == item2.PRO_ID){
                this.dataProVentaV.push({
                    idProd: item.idProd,
                    nombre: item2.PRO_NOMBRE,
                    cantidad: item.cantidad,
                    total: item.total
                })
                }
            }
            }
            setTimeout(() => {
            this.Removerclass();
            this.VerinputsEdit = true;
            }, 900);
        },
        CerrarEditarVent(){
            this.VentasPrin = true;
            this.VentAgregar = false;
            this.VerVentasPro = false;
            this.EditVentasPro = false;
        },
        async GuardaEdit(id:string){
            let inputDesc:any = document.getElementById(id);
            // let data:any = await this.MiServicio.UpdateDescVenta(inputDesc.value, this.dataVentas[this.position].VEN_ID);
            console.log(inputDesc);
            console.log(this.dataVentas[this.position]);
            console.log(this.dataVentas[this.position].VEN_ID);
            const formDataVentas = new URLSearchParams();
                formDataVentas.append('venta_id', this.dataVentas[this.position].VEN_ID);   
                formDataVentas.append('venta_desc', inputDesc.value);     
            var data2:any = await fetch("https://tesis.lmspace.com.mx/php/TiendaT/LHA/consultas.php", {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    },
                body: 
                    formDataVentas.toString()
            });
            var data = await data2.json();
            console.log('%c 🌸 data','color:#CF8103;');
            console.log(data);
            if(data.Response=='Actualización Exitosa'){
                Swal.fire({
                    icon: 'success',
                    title: 'Actualización exitosa.',
                    showConfirmButton: false,
                    showCloseButton: true,
                });
                this.VentasPrin = true;
                this.VentAgregar = false;
                this.VerVentasPro = false;
                this.EditVentasPro = false;
                this.Cargando = true;
                this.verVentas();
            }else{
                Swal.fire({
                    icon: 'error',
                    title: 'Actualización fallida.',
                    showConfirmButton: false,
                    showCloseButton: true,
                });
            }
        }
    }
})
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@font-face {
    font-family: 'ZonaProBold';
    src: url(~@/assets/fonts/ZonaPro-Bold.ttf);
}

@font-face {
    font-family: 'ZonaProSemiBold';
    src: url(~@/assets/fonts/ZonaPro-SemiBold.ttf);
}

@font-face {
    font-family: 'ZonaProItalic';
    src: url(~@/assets/fonts/ZonaPro-RegularItalic.ttf);
}

@font-face {
    font-family: 'ZonaPro';
    src: url(~@/assets/fonts/ZonaPro-Regular.ttf);
}

.CajitaVentas {
    width: 100%;
    height: 100%;
}

.CajitaAgregarVenta {
    width: 100%;
    height: 100%;
    overflow-y: auto;
    padding: 0rem 2rem;
}

.CajitaAgregarVenta::-webkit-scrollbar {
    width: 8px;
    /* Tamaño del scroll en vertical */
    height: 8px;
    /* Tamaño del scroll en horizontal */
    /*display: none;
   Ocultar scroll */
}

.CajitaAgregarVenta::-webkit-scrollbar-thumb {
    /* thumb */
    background: #cacaca;
    border-radius: 50px;
    height: 50px;
}

.CajitaAgregarVenta::-webkit-scrollbar-track {
    /* track */
    background: white;
    border-radius: 50px;
}

.ModalVerVenta {
    width: 100%;
    height: 100%;
    overflow-y: auto;
    background-color: rgba(0, 172, 193, 0.65);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1;
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
    align-items: center;
    align-content: center;
}

.ContentMVVent {
    background-color: white;
    width: 35%;
    height: 90%;
    padding: 2rem 3rem;
    position: relative;
    overflow: auto;
}

.ContentMVVent::-webkit-scrollbar {
    width: 8px;
    /* Tamaño del scroll en vertical */
    height: 8px;
    /* Tamaño del scroll en horizontal */
    /*display: none; Ocultar scroll */
}

.ContentMVVent::-webkit-scrollbar-thumb {
    /* thumb */
    background: #cacaca;
    border-radius: 50px;
    height: 50px;
}

.ContentMVVent::-webkit-scrollbar-track {
    /* track */
    background: white;
    border-radius: 50px;
}

.iconCerrar {
    color: #dc3545;
    font-size: 2.2rem;
    position: absolute;
    right: 1.5%;
    top: 0%;
    cursor: pointer;
}


/*-------------------------------Login---------------------------------------*/

.Cargando {
    /*background-color: rgba( #7896D2, 0.95);*/
    background-color: rgba( #A381AA, 0.85);
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 10;
}

.wrapper {
    width: 200px;
    height: 60px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}

.circle {
    width: 20px;
    height: 20px;
    position: absolute;
    border-radius: 50%;
    background-color: #fff;
    left: 15%;
    transform-origin: 50%;
    animation: circle .5s alternate infinite ease;
}

.circle1 {
    background-color: rgba( #E5A5DF, 1.0);
}

.circle2 {
    background-color: #CEB2EE;
}

.circle3 {
    background-color: #B3C4F9;
}

@keyframes circle {
    0% {
        top: 60px;
        height: 5px;
        border-radius: 50px 50px 25px 25px;
        transform: scaleX(1.7);
    }
    40% {
        height: 20px;
        border-radius: 50%;
        transform: scaleX(1);
    }
    100% {
        top: 0%;
    }
}

.circle:nth-child(2) {
    left: 45%;
    animation-delay: .2s;
}

.circle:nth-child(3) {
    left: auto;
    right: 15%;
    animation-delay: .3s;
}

.shadow {
    width: 20px;
    height: 4px;
    border-radius: 50%;
    background-color: rgba(0, 0, 0, .5);
    position: absolute;
    top: 62px;
    transform-origin: 50%;
    z-index: -1;
    left: 15%;
    filter: blur(1px);
    animation: shadow .5s alternate infinite ease;
}

@keyframes shadow {
    0% {
        transform: scaleX(1.5);
    }
    40% {
        transform: scaleX(1);
        opacity: .7;
    }
    100% {
        transform: scaleX(.2);
        opacity: .4;
    }
}

.shadow:nth-child(4) {
    left: 45%;
    animation-delay: .2s
}

.shadow:nth-child(5) {
    left: auto;
    right: 15%;
    animation-delay: .3s;
}

.wrapper span {
    position: absolute;
    top: 75px;
    font-family: 'ZonaProBold';
    font-size: 2rem;
    letter-spacing: 12px;
    color: #fff;
    text-shadow: 4px 3px 0 #7A51A1;
    left: 15%;
    letter-spacing: 8px;
    left: -4%;
    top: 80px;
}


/*---------------------------------------------------------------------------*/


/*---------------------------------Responsivo------------------------------------------*/

@media screen and (max-width: 1000px) {
    .ContentMVVent {
        width: 65%;
    }
}

@media screen and (max-width: 500px) {
    .ContentMVVent {
        width: 90%;
        height: 94%;
        padding: 2rem 1rem;
    }
}

@media screen and (min-width: 768px) and (min-height: 1024px) {
    .ContentMVVent {
        width: 65%;
        height: 65%;
    }
}

@media screen and (min-width: 800px) and (min-height: 1280px) {
    .ContentMVVent {
        width: 65%;
        height: 55%;
    }
}

@media screen and (min-width: 820px) and (min-height: 1180px) {
    .ContentMVVent {
        width: 60%;
        height: 60%;
    }
}

@media screen and (min-width: 1024px) and (min-height: 600px) {
    .ContentMVVent {
        width: 45%;
        height: 95%;
    }
}

@media screen and (min-width: 1024px) and (min-height: 1366px) {
    .ContentMVVent {
        width: 45%;
        height: 46%;
    }
}

@media screen and (min-width: 1025px) and (min-height: 10px) {
    .ContentMVVent {
        width: 35%;
        height: 90%;
    }
}

</style>
